import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;

  @media (max-width: 768px) {
    padding: 10px;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;

  @media (max-width: 1000px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
`;

export const HeaderTitle = styled.p`
  font-size: 30px;
  font-weight: 600;
  color: #1c1b3a;

  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

export const HeaderItemLeft = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;

  @media (max-width: 1000px) {
    justify-content: space-between;
    width: 100%;
  }
`;

export const HeaderItemRight = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;

  @media (max-width: 768px) {
    justify-content: space-between;
    width: 100%;
  }
`;

export const Content = styled.div`
  display: flex;
  justify-content: space-between;
  column-gap: 30px;
  height: auto;
  flex: 1;

  @media (max-width: 1000px) {
    flex-direction: column;
    row-gap: 50px;
  }
`;

export const TabBenefits = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;
  border-bottom: 1px solid #ddd;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const TabBenefitsContent = styled.div`
  width: 13%;
  margin-right: 2%;
  background: #4948ac;
  color: white;
  padding: 12px 5px 6px 5px;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  text-align: center;

  &:hover {
    cursor: pointer;
  }

  @media (max-width: 1000px) {
    width: 20%;
  }

  @media (max-width: 768px) {
    width: 100%;
    margin: 5px 0;
  }
`;

export const ScrollableContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  row-gap: 20px;
  flex-grow: 1;
  margin: 20px 10px 10px 10px;
  overflow-y: scroll;
  max-height: 800px;
  padding: 10px;

  @media (max-width: 1000px) {
    max-height: 500px;
  }

  @media (max-width: 768px) {
    max-height: 300px;
  }

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-track {
    background: #f3f4f8;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #222247;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const ScrollableContainerEmpty = styled(ScrollableContainer)`
  justify-content: center;
`;
